"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyProjectiles = exports.mkProjectile = void 0;
const __1 = require("../..");
function mkProjectile(args) {
    return args;
}
exports.mkProjectile = mkProjectile;
function applyProjectiles(args) {
    const { projectiles, onProjectile } = args;
    if (projectiles.length === 0) {
        return;
    }
    let { sequence } = args;
    sequence = sequence.pushSequence("parallel");
    projectiles.forEach((projectile, i, all) => {
        const projectileSequence = sequence.pushSequence("sequential");
        if (projectile.jitter > 0) {
            projectileSequence.push(__1.DelayVfxStepArgs.ms(projectile.jitter));
        }
        projectileSequence.push(new __1.ProjectileVfxStepArgs(new __1.ActorVfxLocationSelector(projectile.creatorId, projectile.start || "front-hand"), new __1.ActorVfxLocationSelector(projectile.targetId, projectile.end), projectile.type, projectile.path));
        onProjectile(projectileSequence, projectile, i, all);
    });
}
exports.applyProjectiles = applyProjectiles;
